const email1 = {
  id: 1,
  passage: `Subject: Inquiry About Apartment Listing at 2458 Pinewood Avenue

Dear Ms. Reynolds,

I hope this message finds you well. My name is Daniel Yoon, and I am currently searching for an apartment that <mark>suits</mark> my needs. I recently <mark>came across</mark> your listing for the property located at 2458 Pinewood Avenue, and I am very interested in learning more about it.

Apartment Features & Requirements
I am looking for an apartment that includes the following features:
Number of bedrooms: 2
Number of bathrooms: 2
<mark>Pet-friendliness</mark>: Yes (I have one small dog)
Parking availability : Proximity to public transportation

It would be great if you could provide additional details regarding the <mark>amenities</mark> available, such as laundry facilities, gym, or a <mark>communal</mark> area.

Availability & Viewing Schedule
I am eager to find a new home by April 15, 2025. Please let me know if the apartment is available within that timeframe. If possible, I would appreciate arranging a <mark>viewing</mark> at your earliest convenience, so I can get a better feel for the property.

Rental Application Process
Could you please advise on the application process? I would like to ensure that I have all the necessary documents prepared when the time comes to apply.

Thank you for your time and assistance. I look forward to your response and hopefully to a viewing.

Best regards,
Daniel Yoon`,
  translation: `제목: 2458 Pinewood Avenue 아파트 매물 문의

Reynolds 님께,

안녕하세요. 제 이름은 Daniel Yoon이며, 현재 제 필요에 맞는 아파트를 찾고 있습니다. 최근 2458 Pinewood Avenue에 위치한 귀하의 매물을 보게 되었고, 이에 대해 더 자세히 알고 싶습니다.

아파트 특징 및 요구사항
저는 다음과 같은 특징을 갖춘 아파트를 찾고 있습니다:

침실 수: 2개

욕실 수: 2개

반려동물 허용 여부: 예 (작은 강아지 1마리 있음)

주차 가능 여부

대중교통 접근성

세탁 시설, 체육관, 공용 공간과 같은 편의 시설에 대한 추가 정보를 제공해 주시면 감사하겠습니다.

입주 가능 시기 및 방문 일정
2025년 4월 15일까지 새 집을 찾고 싶습니다. 해당 기간 내에 아파트가 이용 가능한지 알려주시기 바랍니다. 가능하다면, 최대한 빨리 방문 일정을 잡아 부동산에 대해 더 잘 파악하고 싶습니다.

임대 신청 절차
신청 절차에 대해 조언해 주실 수 있을까요? 신청할 때 필요한 모든 서류를 미리 준비하고 싶습니다.

시간과 도움에 감사드립니다. 귀하의 답변과 방문 기회를 기대합니다.

감사합니다,
Daniel Yoon`,
  koreanNouns: `Subject: Inquiry About Apartment Listing at 2458 Pinewood Avenue

Dear Ms. Reynolds,

I hope this message finds you well. My name is Daniel Yoon, and I am currently searching for an apartment that <mark>필요에 맞는</mark> my needs. I recently <mark>우연히 보게 되었다</mark> your listing for the property located at 2458 Pinewood Avenue, and I am very interested in learning more about it.

Apartment Features & Requirements
I am looking for an apartment that includes the following features:
Number of bedrooms: 2
Number of bathrooms: 2
<mark>반려동물 허용 여부</mark>: Yes (I have one small dog)
Parking availability : Proximity to public transportation

It would be great if you could provide additional details regarding the <mark>편의 시설</mark> available, such as laundry facilities, gym, or a <mark>공용의</mark> area.

Availability & Viewing Schedule
I am eager to find a new home by April 15, 2025. Please let me know if the apartment is available within that timeframe. If possible, I would appreciate arranging a <mark>집보기</mark> at your earliest convenience, so I can get a better feel for the property.

Rental Application Process
Could you please advise on the application process? I would like to ensure that I have all the necessary documents prepared when the time comes to apply.

Thank you for your time and assistance. I look forward to your response and hopefully to a viewing.

Best regards,
Daniel Yoon`,
  wordPairs: {
    suits: "필요에 맞는",
    "came across": "우연히 보게 되었다",
    "Pet-friendliness": "반려동물 허용 여부",
    amenities: "편의 시설",
    communal: "공용의",
    viewing: "집보기",
  },
  questions: [],
};
const email2 = {
  id: 2,
  passage: `Subject: Excellent Investment Opportunity – 17 Willow Creek Drive

Dear Mr. Jameson,

I hope this message finds you well. I am reaching out to you as your trusted real estate agent to present an exceptional property sale opportunity that I believe aligns perfectly with your investment goals.

Property Overview
This property is located at 17 Willow Creek Drive, Westbridge, and offers an outstanding <mark>prospect</mark> for both residential living and investment purposes. Here are the key highlights of the property:

Prime Location: <mark>Nestled</mark> in a highly <mark>sought-after</mark> neighborhood with easy access to shopping centers, schools, and public transportation.

Unique Features: Spacious backyard with a private patio, modern kitchen with energy-efficient appliances, and a newly renovated master bathroom.

Flexible Financing: Various financing options, including low-interest fixed-rate loans and investor packages, are available to suit your financial needs.

Investment Potential
Investing in this property presents a promising opportunity for appreciation and rental income. Here's why this property stands out:

Market Growth: The Westbridge area is experiencing <mark>steady</mark> growth, with property values projected to increase by 12% over the next 3 years.

Rental Demand: Due to its proximity to the business district and top-rated schools, there is strong and consistent demand for rental housing in this area.

Comparative Advantage: This property offers more <mark>square footage</mark> and upgraded features compared to similar listings in the neighborhood—providing excellent value.

Next Steps
If you are interested in learning more about this opportunity or would like to schedule a private viewing, please feel free to contact me at your convenience:

sarah.choi@primelivingrealty.com
(917) 555-8032

I'm more than happy to provide you with a full investment analysis or answer any questions you may have. I look forward to assisting you in making a smart and <mark>profitable</mark> real estate investment.

Thank you for considering this opportunity. I look forward to your positive response.

Best regards,
Sarah Choi
Senior Property Consultant`,
  translation: `제목: 탁월한 투자 기회 – 17 윌로우 크릭 드라이브

제임슨 님께,

안녕하세요. 귀하의 신뢰받는 부동산 중개인으로서 귀하의 투자 목표와 완벽하게 일치한다고 생각되는 특별한 부동산 판매 기회를 소개해 드리고자 연락드립니다.

부동산 개요
이 부동산은 웨스트브릿지의 17 윌로우 크릭 드라이브에 위치하고 있으며, 주거 생활과 투자 목적 모두에 탁월한 전망을 제공합니다. 다음은 이 부동산의 주요 특징입니다:

최고의 위치: 쇼핑 센터, 학교, 대중교통에 쉽게 접근할 수 있는 매우 인기 있는 동네에 자리잡고 있습니다.

독특한 특징: 개인 파티오가 있는 넓은 뒷마당, 에너지 효율적인 가전제품이 있는 현대적인 주방, 새롭게 리모델링된 마스터 욕실.

유연한 자금 조달: 저금리 고정금리 대출 및 투자자 패키지를 포함한 다양한 자금 조달 옵션이 귀하의 재정적 필요에 맞게 제공됩니다.

투자 잠재력
이 부동산에 투자하는 것은 가치 상승과 임대 수입에 대한 유망한 기회를 제공합니다. 이 부동산이 돋보이는 이유는 다음과 같습니다:

시장 성장: 웨스트브릿지 지역은 꾸준한 성장을 경험하고 있으며, 부동산 가치는 향후 3년 동안 12% 증가할 것으로 예상됩니다.

임대 수요: 비즈니스 지구와 최고 등급의 학교와의 근접성으로 인해 이 지역에서는 임대 주택에 대한 강력하고 일관된 수요가 있습니다.

비교 우위: 이 부동산은 동네의 유사한 매물에 비해 더 많은 평방 피트와 업그레이드된 기능을 제공하여 탁월한 가치를 제공합니다.

다음 단계
이 기회에 대해 더 알고 싶거나 개인 집보기를 예약하고 싶으시다면, 편하신 시간에 연락해 주세요:

sarah.choi@primelivingrealty.com
(917) 555-8032

전체 투자 분석을 제공하거나 귀하가 가질 수 있는 질문에 답변해 드리겠습니다. 스마트하고 수익성 있는 부동산 투자를 하시는 데 도움을 드리기를 기대합니다.

이 기회를 고려해 주셔서 감사합니다. 긍정적인 답변을 기다리겠습니다.

감사합니다,
사라 최
수석 부동산 컨설턴트`,
  koreanNouns: `Subject: Excellent Investment Opportunity – 17 Willow Creek Drive

Dear Mr. Jameson,

I hope this message finds you well. I am reaching out to you as your trusted real estate agent to present an exceptional property sale opportunity that I believe aligns perfectly with your investment goals.

Property Overview
This property is located at 17 Willow Creek Drive, Westbridge, and offers an outstanding <mark>전망</mark> for both residential living and investment purposes. Here are the key highlights of the property:

Prime Location: <mark>자리잡은</mark> in a highly <mark>인기 있는</mark> neighborhood with easy access to shopping centers, schools, and public transportation.

Unique Features: Spacious backyard with a private patio, modern kitchen with energy-efficient appliances, and a newly renovated master bathroom.

Flexible Financing: Various financing options, including low-interest fixed-rate loans and investor packages, are available to suit your financial needs.

Investment Potential
Investing in this property presents a promising opportunity for appreciation and rental income. Here's why this property stands out:

Market Growth: The Westbridge area is experiencing <mark>꾸준한</mark> growth, with property values projected to increase by 12% over the next 3 years.

Rental Demand: Due to its proximity to the business district and top-rated schools, there is strong and consistent demand for rental housing in this area.

Comparative Advantage: This property offers more <mark>평방 피트</mark> and upgraded features compared to similar listings in the neighborhood—providing excellent value.

Next Steps
If you are interested in learning more about this opportunity or would like to schedule a private viewing, please feel free to contact me at your convenience:

sarah.choi@primelivingrealty.com
(917) 555-8032

I'm more than happy to provide you with a full investment analysis or answer any questions you may have. I look forward to assisting you in making a smart and <mark>수익성 있는</mark> real estate investment.

Thank you for considering this opportunity. I look forward to your positive response.

Best regards,
Sarah Choi
Senior Property Consultant`,
  wordPairs: {
    prospect: "전망",
    Nestled: "자리잡은",
    "sought-after": "인기 있는",
    steady: "꾸준한",
    "square footage": "평방 피트",
    profitable: "수익성 있는",
  },
  questions: [],
};
const email3 = {
  id: 2,
  passage: `Subject: Exciting New Property Opportunities Just For You!

Dear Valued Client,

I hope this email finds you well. As part of my commitment to always keeping you informed about the best real estate opportunities, I am thrilled to share some exciting new property listings that meet your specific criteria.

Featured Properties
1. Modern Urban Apartment
Located in the heart of downtown Los Angeles, this stylish 2-bedroom apartment offers breathtaking city views, modern finishes, and <mark>unbeatable</mark> proximity to local amenities.

2. Cozy Suburban Home
This charming 3-bedroom family home is <mark>situated</mark> in a quiet neighborhood in Maplewood, with excellent schools and parks <mark>nearby</mark>. It features a spacious backyard perfect for gatherings.

3. Luxury Waterfront Villa
Experience the <mark>epitome</mark> of luxury living in this <mark>stunning</mark> 5-bedroom villa located in Malibu, with private beach access and world-class amenities. Perfect for those seeking an exclusive retreat.

Why These Properties Stand Out
Prime locations with great potential for appreciation
High-quality construction and modern amenities
Close to essential services and entertainment

If any of these properties piqued your interest, please let me know at your earliest convenience. I can arrange a private tour or provide further details. Don't miss out on these <mark>exceptional</mark> opportunities!

I look forward to assisting you further in finding your dream property. Thank you for trusting me with your real estate needs.

Warm regards,
Eleanor Park
Seaside Realty Group`,
  translation: `제목: 고객님을 위한 흥미로운 새 부동산 기회!

존경하는 고객님께,

이 이메일이 잘 전달되었기를 바랍니다. 항상 최고의 부동산 기회에 대해 고객님께 알려드리겠다는 저의 약속의 일환으로, 고객님의 특정 기준에 맞는 흥미로운 새 부동산 매물을 공유하게 되어 기쁩니다.

주요 매물
1. 현대적인 도심 아파트
로스앤젤레스 다운타운 중심부에 위치한 이 세련된 2베드룸 아파트는 숨막히는 도시 전망, 현대적인 마감재, 그리고 지역 편의시설과의 타의 추종을 불허하는 근접성을 제공합니다.

2. 아늑한 교외 주택
이 매력적인 3베드룸 가족 주택은 메이플우드의 조용한 동네에 위치해 있으며, 우수한 학교와 공원이 근처에 있습니다. 모임에 완벽한 넓은 뒷마당을 갖추고 있습니다.

3. 럭셔리 해변가 빌라
말리부에 위치한 이 멋진 5베드룸 빌라에서 럭셔리 생활의 정수를 경험하세요. 개인 해변 접근과 세계적 수준의 편의시설을 갖추고 있습니다. 독점적인 휴양지를 찾는 분들에게 완벽합니다.

이 매물들이 돋보이는 이유
가치 상승 잠재력이 큰 최고의 위치

고품질 건축과 현대적인 편의시설

필수 서비스와 엔터테인먼트에 가까움

이 매물 중 어느 것이라도 관심이 있으시다면, 가능한 빨리 알려주세요. 개인 투어를 주선하거나 추가 정보를 제공해 드릴 수 있습니다. 이 특별한 기회를 놓치지 마세요!

고객님의 꿈의 부동산을 찾는 데 더 도움을 드리기를 기대합니다. 고객님의 부동산 요구에 저를 신뢰해 주셔서 감사합니다.

따뜻한 인사를 보내며,
엘리너 박
시사이드 부동산 그룹`,
  koreanNouns: `Subject: Exciting New Property Opportunities Just For You!

Dear Valued Client,

I hope this email finds you well. As part of my commitment to always keeping you informed about the best real estate opportunities, I am thrilled to share some exciting new property listings that meet your specific criteria.

Featured Properties
1. Modern Urban Apartment
Located in the heart of downtown Los Angeles, this stylish 2-bedroom apartment offers breathtaking city views, modern finishes, and <mark>타의 추종을 불허하는</mark> proximity to local amenities.

2. Cozy Suburban Home
This charming 3-bedroom family home is <mark>위치해있다</mark> in a quiet neighborhood in Maplewood, with excellent schools and parks <mark>근처에</mark>. It features a spacious backyard perfect for gatherings.

3. Luxury Waterfront Villa
Experience the <mark>본보기</mark> of luxury living in this <mark>멋진</mark> 5-bedroom villa located in Malibu, with private beach access and world-class amenities. Perfect for those seeking an exclusive retreat.

Why These Properties Stand Out
Prime locations with great potential for appreciation
High-quality construction and modern amenities
Close to essential services and entertainment

If any of these properties piqued your interest, please let me know at your earliest convenience. I can arrange a private tour or provide further details. Don't miss out on these <mark>특별한</mark> opportunities!

I look forward to assisting you further in finding your dream property. Thank you for trusting me with your real estate needs.

Warm regards,
Eleanor Park
Seaside Realty Group`,
  wordPairs: {
    unbeatable: "타의 추종을 불허하는",
    situated: "위치해있다",
    nearby: "근처에",
    epitome: "본보기",
    stunning: "멋진",
    exceptional: "특별한",
  },
  questions: [],
};

export const realEstateEmailQuestions = [email1, email2, email3];
